import { NestedCSSProperties } from "typestyle/lib/types";

export const hSpaced = (spacing: number): NestedCSSProperties => ({
  display: "flex",
  flexDirection: "row",
  $nest: {
    "&>*": {
      marginRight: `${spacing}px`,
    },
    "&>*:last-child": {
      marginRight: "0px",
    },
  },
});

export const vSpaced = (spacing: number): NestedCSSProperties => ({
  display: "flex",
  flexDirection: "column",
  $nest: {
    "&>*": {
      marginBottom: `${spacing}px`,
    },
    "&>*:last-child": {
      marginBottom: "0px",
    },
  },
});
